<template>
  <div class="restaurant-list">
    <!-- Section header -->
    <div v-if="title" class="mb-4">
      <h3 class="text-xl font-bold">{{ title }}</h3>
      <p v-if="subtitle" class="text-sm text-gray-600">{{ subtitle }}</p>
    </div>

    <!-- Loading state -->
    <div v-if="isLoading" class="flex flex-col gap-6 min-w-max">
      <div v-for="i in shimmerCount" :key="`shimmer-${i}`" class="w-full">
        <div class="w-full relative">
          <div
            class="relative w-full h-full top-0 left-0 rounded-3xl overflow-hidden"
          >
            <div class="relative p-[35%] border border-transparent">
              <div
                class="rounded-3xl bg-slate-100 overflow-hidden w-full h-full absolute top-0 left-0 flex items-center flex-col justify-center"
              >
                <div
                  class="absolute w-full h-full duration-300 shimmer-animation"
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Restaurants list (vertical) -->
    <div
      v-else-if="displayedRestaurants && displayedRestaurants.length > 0"
      class="flex flex-col gap-6"
    >
      <div
        v-for="(restaurant, i) in displayedRestaurants"
        :key="restaurant.id || i"
        class="w-full"
      >
        <RestaurantCard :item="restaurant" />
      </div>
    </div>

    <!-- Empty state -->
    <div v-else class="text-center py-8">
      <p class="text-gray-500">Aucun restaurant disponible</p>
    </div>

    <!-- Show more button -->
    <div
      v-if="limit && restaurants && restaurants.length > limit"
      class="mt-6 text-center"
    >
      <div
        @click="showAllRestaurants"
        class="inline-block bg-primary-600 text-white px-6 py-3 rounded-xl font-bold shadow-lg hover:bg-primary-700 transition-colors cursor-pointer"
      >
        Voir tous les restaurants
      </div>
    </div>
  </div>
</template>

<script>
import { computed } from 'vue';
import RestaurantCard from './RestaurantCard.vue';

export default {
  name: 'RestaurantList',

  components: {
    RestaurantCard
  },

  props: {
    restaurants: {
      type: Array,
      default: null
    },
    loading: {
      type: Boolean,
      default: null
    },
    title: {
      type: String,
      default: ''
    },
    subtitle: {
      type: String,
      default: ''
    },
    limit: {
      type: Number,
      default: 0
    },
    shimmerCount: {
      type: Number,
      default: 5
    }
  },

  data() {
    return {
      showPlaceholder: false
    };
  },

  computed: {
    placeholderImage() {
      return '/images/placeholders/restaurant-dishes.png';
    },

    // Use provided restaurants prop, or fall back to store
    restaurantList() {
      if (this.restaurants !== null) {
        return this.restaurants;
      }
      // Read from home store - use popular restaurants
      return this.$stores?.home?.popularRestaurants || [];
    },

    isLoading() {
      if (this.loading !== null) {
        return this.loading;
      }
      // Read from home store
      return this.$stores?.home?.state?.featured?.loading || false;
    },

    displayedRestaurants() {
      if (!this.limit || !this.restaurantList) {
        return this.restaurantList;
      }
      return this.restaurantList.slice(0, this.limit);
    }
  },

  mounted() {
    setTimeout(() => {
      this.showPlaceholder = true;
    }, 5000);
  },

  methods: {
    showRestaurantDetail(restaurant) {
      if (!restaurant || !restaurant.id) return;
      this.$bus.emit('restaurant.SHOW_RESTAURANT_DETAIL', {
        id: restaurant.id
      });
    },

    showAllRestaurants() {
      // TODO: Navigate to restaurants list page
      console.log('Show all restaurants');
    },

    handleImageLoad(event) {
      event.target.style.backgroundColor = 'white';
    },

    handleImageError(event) {
      event.target.style.display = 'none';
    }
  }
};
</script>